module.exports = __webpack_public_path__ + "static/img/main_mainpage_icon03_g.39f1bbae.svg";